import React from "react";
import { Alert, Button, Space } from "antd";
import apiClient from "../api/apiClient";
import useBusinessResource from "../hooks/useBusinessResource";
import WhatsAppRecapWarehouseSelect from "./WhatsAppRecapWarehouseSelect";

const confirmationLabels = {
  pending: "Confirmation en attente", sending: "Confirmation en cours d’envoi",
  accepted: "Confirmation acceptée par WhatsApp", sent: "Confirmation envoyée",
  delivered: "Confirmation livrée", read: "Confirmation lue",
  failed: "Échec de la confirmation", unknown: "Livraison de la confirmation à vérifier",
  expired: "Délai de confirmation WhatsApp expiré",
};

export default function WhatsAppRecapSettings({ active, actorId, companyId, recipientId, ...props }) {
  const consent = useBusinessResource({
    resource: "staff-whatsapp-consent", moduleScope: "admin", parameters: [recipientId || null],
    userId: actorId, companyId, warehouseId: null, scopeLevel: "company",
    enabled: Boolean(active && recipientId), active: Boolean(active && recipientId),
    load: async (signal) => {
      const { data } = await apiClient.get(`/api/users/${recipientId}/whatsapp-recap-status`, { signal });
      if (typeof data.status?.stopped !== "boolean") throw new Error("Statut de désabonnement indisponible.");
      return data.status;
    },
  });
  const resource = useBusinessResource({
    resource: "staff-whatsapp-warehouses", moduleScope: "admin",
    userId: actorId, companyId, warehouseId: null, scopeLevel: "company",
    enabled: Boolean(active), active: Boolean(active),
    load: async (signal) => {
      const { data } = await apiClient.get("/api/users/whatsapp-recap-options", { signal });
      if (!Array.isArray(data.warehouses)) throw new Error("Liste des établissements indisponible.");
      return data.warehouses;
    },
  });
  return <Space direction="vertical" size={8} style={{ width: "100%" }}>
    {consent.data?.stopped ? <Alert type="warning" showIcon
      message="Désabonné par STOP"
      action={props.value?.length ? <Button size="small" disabled={props.disabled}
        onClick={() => props.onChange?.([])}>Retirer la sélection</Button> : undefined}
      description={<>
        {consent.data.stopped_at ? <>Demande du {new Intl.DateTimeFormat("fr-FR", {
          dateStyle: "short", timeStyle: "short", timeZone: "UTC",
        }).format(new Date(consent.data.stopped_at))} UTC. </> : null}
        Les bilans quotidiens sont suspendus pour tous les établissements du numéro enregistré.
        {" "}{confirmationLabels[consent.data.confirmation_status] || "Confirmation à vérifier"}.
        {" "}Un nouvel accord du destinataire est nécessaire avant toute réactivation.
      </>}
    /> : null}
    {consent.error ? <Alert type="warning" showIcon
      message="Le désabonnement WhatsApp n’a pas pu être vérifié. La sélection est conservée."
      action={<Button size="small" onClick={() => consent.refresh().catch(() => {})}>Vérifier à nouveau</Button>}
    /> : null}
    {resource.error ? <Alert
      type="warning" showIcon
      message={resource.data ? "Établissements conservés, actualisation indisponible." : "Les établissements n’ont pas pu être chargés."}
      action={<Button size="small" onClick={() => resource.refresh().catch(() => {})}>Réessayer</Button>}
    /> : null}
    <WhatsAppRecapWarehouseSelect
      {...props}
      companyId={companyId}
      disabled={props.disabled || (!resource.data && Boolean(resource.error)) || Boolean(recipientId &&
        (consent.status !== "verified" || consent.data?.stopped))}
      loading={resource.loading}
      warehouses={resource.data || []}
    />
  </Space>;
}
